module.exports = __webpack_public_path__ + "img/button-register-en.1fbc0bef.png";